import { type FC } from 'react';

export const TailwindIndicator: FC = () => {
  // Don't show in production
  if (process.env.NODE_ENV === 'production') return null;

  return (
    <div className="flex fixed bottom-4 right-8 z-50 justify-center items-center p-3 w-8 h-8 font-mono text-xs text-white rounded-full border border-zinc-800 bg-zinc-950">
      <div className="block sm:hidden">xs</div>
      <div className="hidden sm:block md:hidden">sm</div>
      <div className="hidden md:block lg:hidden">md</div>
      <div className="hidden lg:block xl:hidden">lg</div>
      <div className="hidden xl:block 2xl:hidden">xl</div>
      <div className="hidden 2xl:block">2xl</div>
    </div>
  );
};
